module.exports = __webpack_public_path__ + "assets/img/22_1325_big.4fce624a.jpg";